import React, { useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Tab } from 'semantic-ui-react'
import ClimaCheckService from '~/api/services/climaCheck'
import Layout from '~/components/Layout'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'
import MemoryForm from './Tabs/MemoryForm'
import General from './Tabs/General'
import { useAuth } from '~/routes/components/AuthProvider'
import { ThemeContext } from 'styled-components'

const KPM: React.FC = () => {
  const { t } = useTranslation()
  const { systemData: { languages } } = useAuth()
  const { firstColor, secondaryColor } = useContext(ThemeContext)

  const [isBusy, setIsBusy] = useState(false)
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [startingColVal, setStartingColVal] = useState({
    yourValueColor: '',
    lflValueColor: ''
  })

  const methods = useForm({
    mode: 'onSubmit'
  })

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await ClimaCheckService.getClimaCheckSettings()
      if (response.data?.texts) {
        languages.map(language => {
          if (!response.data.texts[0]?.languages.find(lang => lang.id === language.id)) {
            response.data.texts[0].languages.push({
              id: language.id,
              translation: '',
              label: language.label
            })
          }
        })
      }
      const defaultDairyColor = response.data.yourValueColor || firstColor
      const defaultLflColor = response.data.lflValueColor || secondaryColor
      setStartingColVal({
        yourValueColor: defaultDairyColor,
        lflValueColor: defaultLflColor
      })
      methods.reset({
        ...response.data,
        perimeters: response.data.perimeters.map(perimeter => ({ perimeter })),
        memoryFields: response.data?.memoryFields?.map(field => ({ slug: field })),
        yourValueColor: defaultDairyColor,
        lflValueColor: defaultLflColor
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      data.perimeters = data.perimeters.map(item => item.perimeter)
      await ClimaCheckService.updateClimaCheckSettings({
        ...data,
        memoryFields: data?.memoryFields?.map(memoryField => memoryField?.slug)
      })
      notify(t('Successfully update Clima check settings'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderPanes() {
    const panes = [
      {
        menuItem: t('General'),
        render: () => <General startingColVal={startingColVal} />
      },
      {
        menuItem: t('Memory'),
        render: () => <MemoryForm />
      }
    ]

    return (
      <Tab
        menu={{ secondary: true, pointing: true }}
        activeIndex={activeTabIndex}
        panes={panes}
        onTabChange={(_, data) => setActiveTabIndex(data.activeIndex as number)}
      />
    );
  }

  return <Layout
    title={'KPM'}
    isBusy={isBusy}
    segmented
    onSubmit={methods.handleSubmit(onSubmit)}
    action={t('Update')}
  >
    <FormProvider {...methods}>
      {renderPanes()}
    </FormProvider>
  </Layout>
}
export default KPM